import React from "react";
import OpenDays from "./pages/OpenDays";
import "./App.css";

function App() {
  return (
    <div className="App">
      <OpenDays />
    </div>
  );
}

export default App;
